import {useContext} from 'react';

import type {EagGridStore} from './createEagGridStore';
import {EagGridStoreContext} from './EagGridStoreContext';

export function useEagGridStore(): EagGridStore {
  const store = useContext(EagGridStoreContext);
  if (store === null) {
    throw new Error('useEagGridStore must be used within an EagGridStoreProvider');
  }
  return store;
}
